import * as React from 'react';
import { SVGProps } from 'react';

const IconScreenStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3v1H4v1h4v-1H7V9h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2Zm8 1H2v5h8V3Z"
    />
  </svg>
);
export default IconScreenStrokedSizeXs;
